export default __webpack_public_path__ + "static/media/site-promo-small.ddfcbd46.mp4";